import { Report, Template } from "PFApp/booking/types/manage_reports";
import api from "PFCore/api";
import { Collection } from "PFTypes";

export const fetchReports = () =>
  api<Collection<Report[]>>({
    url: "reports/downloads",
    method: "get",
    params: {
      perPage: 1000
    }
  });

export const fetchReport = (id: number) =>
  api<Report>({
    url: `reports/downloads/${id}`,
    method: "get"
  });

export const fetchTemplates = () =>
  api<Collection<Template[]>>({
    url: "reports/templates",
    method: "get",
    params: {
      perPage: 1000
    }
  });

export const fetchTemplate = (id?: number) =>
  api<Template>({
    url: `reports/templates/${id}`,
    method: "get"
  });

export const deleteReport = (reportId: number) =>
  api<void>({
    url: `reports/downloads/${reportId}`,
    method: "delete"
  });
